import $ from 'jquery';
import dealerSite from 'features/ctas/dealer.site.cta';
import dealerChat from 'features/ctas/dealer.chat.cta';
import raq from 'features/ctas/raq.cta';
import paramByName from 'lib/getParameterByName';
import tdaConfig from 'lib/util/tda.config';
import anClicks from 'lib/analytics/click';

var __dynOfferDetail = window.location.href.indexOf('/landing/dynamic-offer-detail') > -1;
var __offerId = paramByName('offerid');
var __providerId = tdaConfig.chat.provider_id;
/*
  Saatchi TDAs use a /landing/dynamic-offer-detail page
  where they output their own CTAs
  we need to find those CTAs using their selectors
  modify their data-destinations
  and attach our own CTAs back onto them, so that they function

  account for just the CTAs on 'landing/dynamic-offer-detail', for now
  /central/landing/dynamic-offer-detail?offerid=highlander_lease_70623
*/
function offerDetailCtas() {
  var $scope = $('#sa-container #offer-detail'); // comes from their HTMLCode component
  var $clickToChatCta = $("a[data-destination='live-chat']", $scope);
  var $dealerInvViaDealerSite = $('a.sa-inv-click', $scope);
  var $raqCta = $('a[href$="/request-a-quote"]', $scope);

  if ($clickToChatCta.length && __providerId) {
    dealerChat($scope);
  }
  // Their 'View Dealer Inventory' CTAs are really just our 'Visit Dealer Website' CTAs
  if ($dealerInvViaDealerSite.length) {
    $dealerInvViaDealerSite.attr('data-destination', 'dealer-site');
    dealerSite($scope);
  }

  // If we don't do this, their custom CTA will leave off the ?offerId on RAQ CTAs
  if ($raqCta.length) {
    $raqCta.attr('data-destination', 'request-a-quote');
    raq(__offerId, $scope);
  }

  anClicks($scope); // GNY-502, w/out this, their datalayer-link elements are meaningless
}

function specialHandling() {
  if (__dynOfferDetail) {
    offerDetailCtas();
  }
}

export default {
  specialHandling: specialHandling,
};
